export const CURRENCY_TYPES = [
  { value: "TRY", label: "TRY" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
];

export const PlayerStates = {
  NOTSTARTED: 0,
  PLAYING: 1,
  PAUSED: 2,
  FINISHED: 3,
};

export const booleanstatus = [
  { value: false, label: "Kapalı" },
  { value: true, label: "Açık" },
];

export const booleanstatus_tr = [
  { value: false, label: "Kapalı" },
  { value: true, label: "Açık" },
];

export const boolenstatus_en = [
  { value: false, label: "Off" },
  { value: true, label: "On" },
];

export const custodyUserTypes_en = [
  { value: "driver", label: "Driver" },
  { value: "attendant", label: "Attendant" },
];

export const custodyUserTypes_tr = [
  { value: "driver", label: "Sürücü" },
  { value: "attendant", label: "Yardımcı Personel" },
];

export const custodyType_en = [
  { value: "clothing", label: "Clothing" },
  { value: "device", label: "Device" },
  { value: "equipment", label: "Equipment" },
  { value: "other", label: "Other" },
];

export const custodyType_tr = [
  { value: "clothing", label: "Giysi" },
  { value: "device", label: "Cihaz" },
  { value: "equipment", label: "Ekipman" },
  { value: "other", label: "Diğer" },
];

export const custodyStatus_en = [
  { value: "active", label: "Assigned" },
  { value: "returned", label: "Returned" },
  { value: "lost", label: "Lost" },
  { value: "damaged", label: "Damaged" },
];

export const custodyStatus_tr = [
  { value: "active", label: "Zimmetli" },
  { value: "returned", label: "İade Edildi" },
  { value: "lost", label: "Kayıp" },
  { value: "damaged", label: "Hasarlı" },
];

export const custodyConditions_en = [
  { value: "new", label: "New" },
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
  { value: "poor", label: "Poor" },
];
export const custodyConditions_tr = [
  { value: "new", label: "Yeni" },
  { value: "good", label: "İyi" },
  { value: "fair", label: "Orta" },
  { value: "poor", label: "Kötü" },
];

export const discountTypes = [
  { value: 1, label: "Yüzde" },
  { value: 2, label: "Meblağ" },
];

export const paymentMethods = [
  { value: 1, label: "Nakit" },
  { value: 2, label: "Kredi Kartı" },
  { value: 3, label: "Mail Order" },
  { value: 5, label: "Çek/Senet" },
  { value: 7, label: "EFT" },
  { value: 8, label: "Mahsup Ödeme" },
  { value: 9, label: "Harici Ödeme Yöntemleri" },
];

export const expenseTypes = [
  { value: 1, label: "Çalışan Ödemesi" },
  { value: 2, label: "Yakıt" },
  { value: 3, label: "Kira" },
  { value: 4, label: "Ofis Harcamaları" },
  { value: 5, label: "Satın Alma Ödemesi" },
  { value: 6, label: "Yazılım Sunucu Ödemesi" },
  { value: 7, label: "Kayıt Dışı Harici Ödeme" },
  { value: 8, label: "Diğer" },
];

export const paymentTypes = [
  { value: 1, label: "Aylık Ödeme" },
  { value: 2, label: "Peşin Ödeme" },
];

export const banks = [
  { value: 0, label: "Nakit Ödeme" },
  { value: 1, label: "Vakıfbank" },
  { value: 2, label: "Garanti Bankası" },
  { value: 3, label: "İş Bankası" },
  { value: 4, label: "Ziraat Bankası" },
  { value: 5, label: "Ziraat Katılım Bankası" },
  { value: 6, label: "TEB" },
  { value: 7, label: "Deniz Bank" },
];

export const isSinglePaymentOptions = [
  { value: true, label: "Tek Çekim" },
  { value: false, label: "Taksitli" },
];

export const installmentCountOptions = [
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
];

export const isOfficial = [
  { value: false, label: "Hayır" },
  { value: true, label: "Evet" },
];

export const TRAVEL_STATUS_TYPE = {
  NOTSTARTED: 1,
  GOING_TO_SCHOOL: 2,
  ARRIVED_SCHOOL: 3,
  PREPARING_AT_SCHOOL: 4,
  LEAVED_SCHOOL: 5,
  FINISHED: 6,
  QR_NEADED: 7,
};

// NOTE: labels are i18n keys (resolved via t() at the call site), matching
// TRAVEL_ACTION_TYPE_EXPLANATIONS below. Do not render `.label` directly.
export const TRAVEL_STATUS_TYPE_EXPLANATIONS = [
  { value: TRAVEL_STATUS_TYPE.NOTSTARTED, label: "travelStatusNotStarted" },
  { value: TRAVEL_STATUS_TYPE.GOING_TO_SCHOOL, label: "travelStatusGoingToSchool" },
  { value: TRAVEL_STATUS_TYPE.ARRIVED_SCHOOL, label: "travelStatusArrivedSchool" },
  { value: TRAVEL_STATUS_TYPE.PREPARING_AT_SCHOOL, label: "travelStatusPreparingAtSchool" },
  { value: TRAVEL_STATUS_TYPE.LEAVED_SCHOOL, label: "travelStatusLeavedSchool" },
  { value: TRAVEL_STATUS_TYPE.FINISHED, label: "travelStatusFinished" },
  { value: TRAVEL_STATUS_TYPE.QR_NEADED, label: "travelStatusQrNeeded" },
];

export const TRAVEL_ACTION_TYPE = {
  STARTED: 1,
  APPROACH_TO_HOME: 2,
  STUDENT_GETON_INFO: 3,
  ARRIVED_SCHOOL: 4,
  QR_READED: 5,
  LEAVED_SCHOOL: 6,
  FINISHED: 7,
  QR_NEADED: 8,
};

export const TRAVEL_ACTION_TYPE_EXPLANATIONS = [
  { value: TRAVEL_ACTION_TYPE.STARTED, label: "started" },
  {
    value: TRAVEL_ACTION_TYPE.APPROACH_TO_HOME,
    label: "approachToHomeParentInformed",
  },
  {
    value: TRAVEL_ACTION_TYPE.STUDENT_GETON_INFO,
    label: "studentNotGetOn",
  },
  { value: TRAVEL_ACTION_TYPE.ARRIVED_SCHOOL, label: "enteredSchool" },
  { value: TRAVEL_ACTION_TYPE.QR_READED, label: "qrCodeReaded" },
  { value: TRAVEL_ACTION_TYPE.LEAVED_SCHOOL, label: "leavedSchool" },
  { value: TRAVEL_ACTION_TYPE.FINISHED, label: "routeFinished" },
  { value: TRAVEL_ACTION_TYPE.QR_NEADED, label: "qrCodeNeeded" },
];

export const APPROACH_TO_HOME_TYPE = {
  PARENT_INFORMED: 1,
  PARENT_NOT_INFORMED: 2,
  PARENT_NOT_INFORMED_STUDENT_NOTGETON: 3,
};

export const APPROACH_TO_HOME_TYPE_EXPLANATIONS = [
  {
    value: APPROACH_TO_HOME_TYPE.PARENT_INFORMED,
    label: "approachToHomeParentInformed",
  },
  {
    value: APPROACH_TO_HOME_TYPE.PARENT_NOT_INFORMED,
    label: "approachToHomeParentNotInformed",
  },
  {
    value: APPROACH_TO_HOME_TYPE.PARENT_NOT_INFORMED_STUDENT_NOTGETON,
    label: "approachToHomeStudentNotGetOn",
  },
];

export const STUDENT_GETON_INFO_TYPE = {
  GETON_PARENT_INFORMED: 1,
  GETON_PARENT_NOT_INFORMED: 2,

  NOT_GETON_PARENT_INFORMED: 3,
  NOT_GETON_PARENT_NOT_INFORMED: 4,

  GETOFF_PARENT_INFORMED: 5,
  GETOFF_PARENT_NOT_INFORMED: 6,
};

export const STUDENT_GETON_INFO_TYPE_EXPLANATIONS = [
  {
    value: STUDENT_GETON_INFO_TYPE.GETON_PARENT_INFORMED,
    label: "Öğrenci Bindi Bilgisi",
  },
  {
    value: STUDENT_GETON_INFO_TYPE.GETON_PARENT_NOT_INFORMED,
    label: "Öğrenci Bindi Bilgisi (Kapalı)",
  },
  {
    value: STUDENT_GETON_INFO_TYPE.NOT_GETON_PARENT_INFORMED,
    label: "studentNotGetOn",
  },
  {
    value: STUDENT_GETON_INFO_TYPE.NOT_GETON_PARENT_NOT_INFORMED,
    label: "studentNotGetOnDisabled",
  },
  {
    value: STUDENT_GETON_INFO_TYPE.GETOFF_PARENT_INFORMED,
    label: "Öğrenci İndi Bilgisi",
  },
  {
    value: STUDENT_GETON_INFO_TYPE.GETOFF_PARENT_NOT_INFORMED,
    label: "Öğrenci İndi Bilgisi (Kapalı)",
  },
];

export const ARRIVED_SCHOOL_TYPE = {
  BUS_ARRIVED: 1,
  PARENT_INFORMED: 2,
  PARENT_NOT_INFORMED: 3,
  PARENT_NOT_INFORMED_STUDENT_NOTGETON: 4,
};

export const ARRIVED_SCHOOL_TYPE_EXPLANATIONS = [
  { value: ARRIVED_SCHOOL_TYPE.BUS_ARRIVED, label: "enteredSchool" },
  { value: ARRIVED_SCHOOL_TYPE.PARENT_INFORMED, label: "enteredSchoolInformed" },
  {
    value: ARRIVED_SCHOOL_TYPE.PARENT_NOT_INFORMED,
    label: "enteredSchoolInformedDisabled",
  },
  {
    value: ARRIVED_SCHOOL_TYPE.PARENT_NOT_INFORMED_STUDENT_NOTGETON,
    label: "enteredSchoolNotGetOnDisabled",
  },
];

export const LEAVED_SCHOOL_TYPE = {
  BUS_LEAVED: 1,
  PARENT_INFORMED: 2,
  PARENT_NOT_INFORMED: 3,
};

export const TRAVEL_LEAVED_TYPE_EXPLANATIONS = [
  { value: LEAVED_SCHOOL_TYPE.BUS_LEAVED, label: "leavedSchool" },
  { value: LEAVED_SCHOOL_TYPE.PARENT_INFORMED, label: "leavedSchoolInformed" },
  { value: LEAVED_SCHOOL_TYPE.PARENT_NOT_INFORMED, label: "leavedSchoolInformedDisabled" },
];

export const vehicleroutetypes = [
  { value: 100, label: "Toplama" },
  { value: 200, label: "Dağıtma" },
];

export const vehicleroutetypes_tr = [
  { value: 100, label: "Toplama" },
  { value: 200, label: "Dağıtma" },
];

export const vehicleroutetypes_en = [
  { value: 100, label: "Pickup" },
  { value: 200, label: "Drop-off" },
];

export const personelServiceRouteTypesIncludeBoth_tr = [
  { value: "PICK_UP", label: "Toplama" },
  { value: "DROP_OFF", label: "Dağıtma" },
  { value: "BOTH", label: "Toplama ve Dağıtma" },
];

export const personelServiceRouteTypesIncludeBoth_en = [
  { value: "PICK_UP", label: "Pickup" },
  { value: "DROP_OFF", label: "Drop-off" },
  { value: "BOTH", label: "Both Pickup and Drop-off" },
];

export const personelServiceRouteTypes_tr = [
  { value: "PICK_UP", label: "Toplama" },
  { value: "DROP_OFF", label: "Dağıtma" },
];

export const personelServiceRouteTypes_en = [
  { value: "PICK_UP", label: "Pickup" },
  { value: "DROP_OFF", label: "Drop-off" },
];

export const personelServiceRouteTypes = [
  { value: "100", label: "Toplama" },
  { value: "200", label: "Dağıtma" },
];

export const schooltypes = [
  { value: 1, label: "Okul" },
  { value: 2, label: "Personel" },
];

export const qrcodetypes_tr = [
  { value: 1, label: "Evet" },
  { value: 2, label: "Hayır" },
];

export const qrcodetypes_en = [
  { value: 1, label: "Yes" },
  { value: 2, label: "No" },
];

export const stationtypes = [
  { value: 1, label: "Personel Durağı" },
  { value: 2, label: "Bağımsız Durak" },
];

export const transfertypes = [
  { value: 100, label: "Toplama" },
  { value: 200, label: "Bırakma" },
];

export const notificationtypes = [
  { value: 1, label: "Uygulama İçi" },
  { value: 2, label: "Uygulama İçi" },
  { value: 3, label: "Uygulama İçi" },
];

export const notificationmethods = [
  { value: 1, label: "Süre" },
  { value: 2, label: "Uzaklık" },
];

export const durations = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
];

export const distances = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
];

export const isCompanyReceiptOptions = [
  { value: false, label: "Hayır" },
  { value: true, label: "Evet" },
];

export const userApproved = [
  { value: false, label: "Hayır" },
  { value: true, label: "Evet" },
];

export const sendUserApprovel = [
  { value: false, label: "Hayır" },
  { value: true, label: "Evet" },
];

export const yesNoOptions = [
  { value: true, label: "Evet" },
  { value: false, label: "Hayır" },
];

export const yesNoOptions_tr = [
  { value: true, label: "Evet" },
  { value: false, label: "Hayır" },
];

export const yesNoOptions_en = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const isActiveOptions = [
  { value: false, label: "Pasif" },
  { value: true, label: "Aktif" },
];

export const isActiveOptions_tr = [
  { value: false, label: "Pasif" },
  { value: true, label: "Aktif" },
];

export const isActiveOptions_en = [
  { value: false, label: "Inactive" },
  { value: true, label: "Active" },
];

export const transferStatus = [
  { value: false, label: "Aktif" },
  { value: true, label: "Pasif" },
];

export const languages = [
  {
    code: "en",
    name: "English",
    country_code: "us",
  },
  {
    code: "tr",
    name: "Türkçe",
    country_code: "tr",
  },
  // {
  //   code: "de",
  //   name: "Deutsch",
  //   country_code: "de",
  // },
];

export const languages_only_tr = [
  {
    code: "tr",
    name: "Türkçe",
    country_code: "tr",
  },
];

export const days = [
  { value: "1", label: "Pazartesi" },
  { value: "2", label: "Salı" },
  { value: "3", label: "Çarşamba" },
  { value: "4", label: "Perşembe" },
  { value: "5", label: "Cuma" },
  { value: "6", label: "Cumartesi" },
  { value: "7", label: "Pazar" },
];

export const days_en = [
  { value: "1", label: "Monday" },
  { value: "2", label: "Tuesday" },
  { value: "3", label: "Wednesday" },
  { value: "4", label: "Thursday" },
  { value: "5", label: "Friday" },
  { value: "6", label: "Saturday" },
  { value: "7", label: "Sunday" },
];

export const fileTypeOptions = [
  { value: "Excel", label: "Excel" },
  { value: "CSV", label: "CSV" },
];

export const ownerShipTypes = [
  { value: "owned", label: "Özmal" },
  { value: "rentedWithDriver", label: "Sürücülü Kiralık" },
  { value: "rentedWithoutDriver", label: "Sürücüsüz Kiralık" },
];

export const driverEmploymentTypes = [
  { value: "company", label: "Şirket Sürücüsü" },
  { value: "external", label: "Diğer Sürücü" },
];

export const yesNoUnknowTypes = [
  { value: "yes", label: "Evet" },
  { value: "no", label: "Hayır" },
  { value: "unkown", label: "Bilinmiyor" },
];

export const plateTypes = [
  { value: "binek", label: "Binek" },
  { value: "sivil", label: "Sivil" },
  { value: "cplate", label: "C Plaka" },
];

export const vehiclePackageTypes = [
  { value: "passengerPackage", label: "Yolcu Paket" },
  { value: "studentPackage", label: "Öğrenci Paket" },
];

export const criminalRecordTypes = [
  { value: "unkown", label: "Bilinmiyor" },
  { value: "ok", label: "Sabıkası yok" },
  { value: "sabikali", label: "Sabıkalı/Uygunsuz" },
  { value: "availableSabikali", label: "Sabıkalı/Uygun" },
];

export const graduationTypes = [
  { value: "unkown", label: "Bilinmiyor" },
  { value: "ilk", label: "İlkokul" },
  { value: "orta", label: "Ortaokul" },
  { value: "lise", label: "Lise" },
  { value: "onlisans", label: "Önlisans" },
  { value: "lisans", label: "Lisans" },
];

export const vehicleQRAttendanceTypes_tr = [
  { value: "NOT_USED", label: "Kullanılmıyor" },
  { value: "PICK_UP_ONLY", label: "Sadece Toplama Servislerinde" },
  { value: "DROP_OFF_ONLY", label: "Sadece Dağıtma Servislerinde" },
  { value: "BOTH", label: "Toplama ve Dağıtma Servislerinde" },
];

export const vehicleQRAttendanceTypes_en = [
  { value: "NOT_USED", label: "Not Used" },
  { value: "PICK_UP_ONLY", label: "Pick-up Services Only" },
  { value: "DROP_OFF_ONLY", label: "Drop-off Services Only" },
  { value: "BOTH", label: "Both Pick-up and Drop-off Services" },
];
